export function pipedrive() {
  (function attachOnClickChatbotTrigger() {
    var chatbotLinks = document.querySelectorAll("a");
    if (chatbotLinks) {
      chatbotLinks.forEach(function (link) {
        if (link.getAttribute("href") === "#pipedrive") {
          link.addEventListener("click", function (event) {
            event.preventDefault();
            LeadBooster.trigger("open");
          });
        }
      });
    }
  })();
}
